const BOOKINGS_MAIN_PAGE_EDITOR_X_PRESET_ID = 'Wix_Bookings_Offering_List_Main_Page_Editor_X';
const BOOKINGS_MAIN_PAGE_PRESET_ID = 'Wix_Bookings_Offering_List_Main_Page';
export const getPresetId = (isEditorX, tpaData) => {
  if (tpaData != null && tpaData.content) {
    return JSON.parse(tpaData.content).presetId;
  } else {
    return isEditorX ? BOOKINGS_MAIN_PAGE_EDITOR_X_PRESET_ID : BOOKINGS_MAIN_PAGE_PRESET_ID;
  }
};
export const cleanNulls = object => {
  object && Object.keys(object).forEach(
  // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
  key => object[key] === null && delete object[key]);
  return object;
};
//# sourceMappingURL=utils.js.map